// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".fr-select[data-v-601ee24c]{padding:5px;margin-bottom:5px;width:100%;transition:box-shadow .25s ease;border:1px solid rgba(0,0,0,.5)}.fr-select[data-v-601ee24c]:focus{outline:none;box-shadow:0 0 3px rgba(0,0,0,.3)}", ""]);
// Exports
module.exports = exports;
